// extracted by mini-css-extract-plugin
module.exports = {"spellifyContainer":"spellify_spellifyContainer__hPKvT"};